"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SameSite = void 0;
var SameSite;
(function (SameSite) {
    SameSite["None"] = "None";
    SameSite["Lax"] = "Lax";
    SameSite["Strict"] = "Strict";
})(SameSite || (exports.SameSite = SameSite = {}));
